import HttpService from './HttpService'

const _http = new HttpService()
export default {
  show: (page, options = null) => {
    let _parans = `?page=${page - 1}`;
    if (options) {
      if(options.search) {
        _parans += `&search=${options.search}`;
      }
      if (options.orderByKey) {
        _parans += `&order_by=${options.orderByKey}`
      }
      if (options.ascOrDes) {
        _parans += '&asc'
      }
    }
    return _http.get(`/api/teacher${_parans}`)
  },
  autoComplete: (search) => {
    return _http.get(`/api/teacher/auto-complete?page=${0}&search=${search}&asc`)
  },
  autoCompleteAll: (search) => {
    return _http.get(`/api/teacher/auto-complete-all?page=${0}&search=${search}&asc`)
  },
  find: (id) => {
    return _http.get(`/api/teacher/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/teacher', payload)
  },
  update: (payload) => {
    return _http.put('/api/teacher', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/teacher/${id}`)
  },
  change_data_intra: (id, payload) => {
    return _http.patch(`/api/teacher?id=${id}`, payload);
  },
}